(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _header = require("./view/_header");

var _header2 = _interopRequireDefault(_header);

var _modal = require("./view/_modal");

var _modal2 = _interopRequireDefault(_modal);

var _loading = require("./view/_loading");

var _loading2 = _interopRequireDefault(_loading);

var _point = require("./view/_point");

var _point2 = _interopRequireDefault(_point);

var _smooth = require("./view/_smooth");

var _smooth2 = _interopRequireDefault(_smooth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./view/_header":2,"./view/_loading":3,"./view/_modal":4,"./view/_point":5,"./view/_smooth":6}],2:[function(require,module,exports){
'use strict'; // menu

$('#js-menu').click(function () {
  $('.l-navigation').addClass('is-open');
  $('html').addClass('is-fixed');
});
$('.l-navigation__close').click(function () {
  $('.l-navigation').removeClass('is-open');
  $('html').removeClass('is-fixed');
}); // howto

$('#js-hint').click(function () {
  $('.l-howto').addClass('is-open');
  $('html').addClass('is-fixed');
});
$('.l-howto__close').click(function () {
  $('.l-howto').removeClass('is-open');
  $('html').removeClass('is-fixed');
}); // sound

$(function () {
  var audioBtn = $('#js-soundPlayer');
  var audio = $('#js-audio');
  audioBtn.on('click', function () {
    audio.volume = 1;

    if (audioBtn.hasClass('is-active')) {
      audio[0].pause();
      audio.removeClass('play');
      audioBtn.removeClass('is-active');
    } else {
      audio[0].play();
      audio.addClass('play');
      audioBtn.addClass('is-active');
    }
  });
}); // pause

function pause() {
  var audioBtn = $('#js-soundPlayer');
  var audio = $('#js-audio');

  if (audioBtn.hasClass('is-active')) {
    audio[0].pause();
    audio.removeClass('play');
    audioBtn.removeClass('is-active');
  }
}

window.addEventListener('blur', pause, false); // height

window.addEventListener('load', function () {
  setTimeout(function () {
    setHeight();
  }, 100);
});
window.addEventListener('orientationchange', function () {
  setTimeout(function () {
    setHeight();
  }, 100);
});
window.addEventListener('resize', function () {
  setTimeout(function () {
    setHeight();
  }, 100);
});

function setHeight() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + "px");
}

},{}],3:[function(require,module,exports){
'use strict';

$(window).on('load', function () {
  var _docH = $(document).innerHeight();

  var _winH = $(window).innerHeight();

  var _bottom = _docH - _winH;

  if (_bottom > 0) {
    $('html').delay(500).animate({
      scrollTop: _bottom,
      easing: 'easeInOutBack'
    }, 1500);
    setTimeout(function () {
      $('#js-loading').addClass('is-done');
    }, 500);
    setTimeout(function () {
      $('html').addClass('is-fixed');
      $('#js-opModal').fadeIn();
    }, 2000);
  } else {
    setTimeout(function () {
      $('#js-loading').addClass('is-done');
    }, 500);
    setTimeout(function () {
      $('html').addClass('is-fixed');
      $('#js-opModal').fadeIn();
    }, 1000);
  }

  setTimeout(function () {
    var _wrapper = $('#awesome');

    var _mainW = _wrapper.width();

    var _width = $(window).width();

    if (_mainW > _width) {
      var _margin = (_mainW - _width) / 2 - 20;

      _wrapper.scrollLeft(_margin);

      console.log(_margin);
    }
  }, 200);
});

},{}],4:[function(require,module,exports){
'use strict'; // modal open

$('.js-modalOpen').click(function () {
  $('.js-modal').fadeIn();
  $('html').addClass('is-fixed');
});
$(document).on('click', '.js-awesomeModalOpen', function () {
  var _target = $(this).data('target');

  $('html').addClass('is-fixed');
  $('.p-awesomeModal--' + _target).fadeIn();

  if (_target == 'category') {
    var _category = $(this).data('category');

    var _modal = $('.p-awesomeModal--category .p-awesomeModal__content');

    var _categorySec = $('.p-awesome__category[data-position="' + _category + '"]');

    var _scrollPos = _categorySec.position().top - _modal.position().top;

    _modal.stop().animate({
      scrollTop: _modal.scrollTop() + _scrollPos
    });
  } else {
    var _modal = $('.p-awesomeModal--' + _target).find('.p-awesomeModal__content');

    _modal.stop().animate({
      scrollTop: 0
    });
  }

  if ($('.l-navigation').hasClass('is-open')) {
    $('.l-navigation').removeClass('is-open');
  }

  if ($('.l-howto').hasClass('is-open')) {
    $('.l-howto').removeClass('is-open');
  }
}); // modal close

$('.js-modalClose, .js-modalBg').click(function () {
  $(this).parents('.js-modal').fadeOut();
  $('html').removeClass('is-fixed');
});
$(document).on('click', '.js-back', function () {
  $(this).parent('.p-awesome__modal').fadeOut();

  if ($('.l-navigation').hasClass('is-open')) {
    $('.l-navigation').removeClass('is-open');
  }

  if ($('.l-howto').hasClass('is-open')) {
    $('.l-howto').removeClass('is-open');
  }

  if ($('html').hasClass('is-fixed')) {
    $('html').removeClass('is-fixed');
  }
});

},{}],5:[function(require,module,exports){
'use strict'; // modal open

var _modalFlg = false;

var _confetti = document.createElement('js-confetti');

document.body.appendChild(_confetti);
var _colors = ['#E18322', '#DFDFDF', '#DFCA40', '#53ABBB'];
$('[data-point]').click(function () {
  var _point = $(this).data('point');

  var _bord = $('#js-point');

  var _total = parseInt(_bord.text()) + _point;

  if (_total > 35999) {
    _total = 36000;

    if (!_modalFlg) {
      _modalFlg = true;
      $('#js-CongratulationModal').fadeIn();
      $('html').addClass('is-fixed');
      confetti({
        particleCount: 140,
        spread: 180,
        origin: {
          y: 0.25
        },
        colors: _colors
      });
    }
  }

  _total = _total.toString().padStart(6, '0');

  _bord.text(_total);
});

},{}],6:[function(require,module,exports){
"use strict";

$(function () {
  $('.js-awesome__scrollLink').click(function () {
    var speed = 500;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top;
    $('html, body').animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});

},{}]},{},[1]);
